module.exports = __webpack_public_path__ + "img/initiative_block1.3e1b1579.jpg";